import Vue from 'vue';
import { getErrorMessage } from '@/main';
const defaultToastOptions = {
    solid: true,
    toaster: 'b-toaster-top-center',
};
let toastVm = null;
const ensureToastVm = () => {
    if (!toastVm) {
        toastVm = new Vue();
    }
    return toastVm;
};
const getBvToast = () => ensureToastVm().$bvToast;
const isHtmlMessage = (message) => /<[a-z][\s\S]*>/i.test(message);
const toToastContent = (message) => {
    const renderHtml = isHtmlMessage(message);
    if (!renderHtml) {
        return message;
    }
    const h = ensureToastVm().$createElement;
    return [
        h('span', {
            domProps: { innerHTML: message },
        }),
    ];
};
const showToast = (message, options = {}) => {
    const bvToast = getBvToast();
    if (!bvToast) {
        console.error('BootstrapVue toast is not available.');
        return;
    }
    const { variant = 'info', autoHideDelay = 5000, ...bvOptions } = options;
    bvToast.toast(toToastContent(message), {
        ...defaultToastOptions,
        variant,
        autoHideDelay,
        ...bvOptions,
    });
};
const showWarningToast = (errorOrMessage, options = {}) => {
    const message = typeof errorOrMessage === 'string' ? errorOrMessage : getErrorMessage(errorOrMessage);
    showToast(message, {
        title: 'Warning',
        variant: 'default',
        headerClass: 'font-weight-bold',
        bodyClass: 'border-warning border-b-2-solid',
        ...options,
    });
};
const showErrorToast = (errorOrMessage, options = {}) => {
    const message = typeof errorOrMessage === 'string' ? errorOrMessage : getErrorMessage(errorOrMessage);
    showToast(message, {
        title: 'Error',
        variant: 'default',
        headerClass: 'font-weight-bold',
        bodyClass: 'border-danger border-b-2-solid',
        noAutoHide: true,
        ...options,
    });
};
const showErrorToastWithTimeout = (errorOrMessage, title) => {
    const responseStatus = errorOrMessage?.response?.status;
    if (responseStatus === 504) {
        showErrorToast('The request timed out. Try reducing the number of structures to export.', {
            title: title,
        });
        return;
    }
    showErrorToast(errorOrMessage, {
        title: title,
    });
};
export { showToast, showErrorToast, showErrorToastWithTimeout, showWarningToast };
